import { useState } from "react";

import Styles from "./ScrollableTabs.styles";
import { ScrollableOption } from "./ScrollableTabs.types";
import { ScrollableTabsProps as Props } from "./ScrollableTabs.types";

const ScrollableTabs = <T,>(props: Props<T>) => {
  const { className, onChange, options } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  const pressHandler = (name: T, index: number) => {
    setActiveIndex(index);
    onChange?.(name, index);
  };

  const renderItem = (listItem: ScrollableOption<T>, index: number) => {
    const { name, title, icon } = listItem;
    const activeStyle =
      activeIndex === index ? "ScrollableTabs__item__label-active" : [];

    return (
      <div
        key={index}
        className="ScrollableTabs__item"
        onClick={() => pressHandler(name, index)}
      >
        {icon ? <div className="ScrollableTabs__item__icon">{icon}</div> : null}
        <div className="ScrollableTabs__item__label__container">
          <p className={`ScrollableTabs__item__label ${activeStyle}`}>
            {title}
          </p>
          {activeIndex === index ? (
            <div className="ScrollableTabs__item__marker" />
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <Styles className={`ScrollableTabs ${className}`}>
      {options.map((item, index) => {
        return renderItem(item, index);
      })}
    </Styles>
  );
};

export default ScrollableTabs;
